<template>
    <div class="quantity-discount pt-2">
        <div class="sticky-top" style="top:0px;background-color:#f9f9f9;z-index:2;">
            <div class="d-flex flex-wrap align-items-center justify-content-between gap-2  mb-2 ">
                <!-- Store Selector -->
                <div class="d-flex flex-wrap gap-2 mt-3">
                    <div class="d-inline-flex gap-2 w-100">
                        <div class="w-75">
                            <input v-model="searchTerm" class="rounded-pill border-0 shadow-sm p-2 position-relative"
                                   placeholder="Cerca Prodotto per nome/sku" style="min-width: 350px" type="text">
                        </div>
                        <div v-for="flag in flags" :key="flag.code" class="position-relative"
                             style="min-width: 36px; flex-basis: 0;">
                            <input :id="'store-' + flag.code" v-model="selectedChannel" :value="flag.code"
                                   class="form-check-input position-absolute visually-hidden" type="radio"
                                   @change="getProductList"/>

                            <label :class="{ active: selectedChannel === flag.code }" :for="'store-' + flag.code"
                                   class="card form-check-label custom-card cursor-pointer text-center d-block">
                                <div class="p-1 card-body hover-border-primary">
                                    <img :alt="getSaleChannelName(flag.code)" :src="flag.label" class="mb-1"
                                         style="width: 24px; height: auto;"/>
                                </div>
                            </label>
                        </div>
                    </div>


                </div>
                <div class="d-inline-flex gap-3">
                    <div class="text-nowrap bg-light border rounded-pill px-3 py-1 shadow-sm d-flex align-items-center">
                        <small class="text-muted me-2 mb-0">Store:</small>
                        <span class="fw-bold fs-6 text-dark">{{ getSaleChannelName(selectedChannel) }}</span>
                    </div>

                    <button class="btn btn-icon btn-icon-only btn-foreground-alternate shadow" data-bs-original-title="Filtri avanzati"
                            data-bs-target="#advancedFilters" data-bs-toggle="modal"
                            type="button">
                        <svg class="acorn-icons acorn-icons-filter d-inline-block text-primary" fill="none" height="20" stroke="currentColor" stroke-linecap="round"
                             stroke-linejoin="round" stroke-width="1.5" viewBox="0 0 20 20" width="20"
                             xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M15 2H5C4.44772 2 4 2.44772 4 3V6.21639C4 6.44606 4.07906 6.66873 4.22389 6.84698L7.4904 10.8673C7.63523 11.0456 7.71429 11.2682 7.71429 11.4979V16.0963C7.71429 16.475 7.92829 16.8213 8.26707 16.9907L10.8385 18.2764C11.5034 18.6088 12.2857 18.1253 12.2857 17.382V11.4979C12.2857 11.2682 12.3648 11.0456 12.5096 10.8673L15.7761 6.84698C15.9209 6.66873 16 6.44606 16 6.21639V3C16 2.44772 15.5523 2 15 2Z">
                            </path>
                        </svg>
                    </button>

                    <button class="btn btn-primary rounded-pill mb-1" @click="openImportModal">Import</button>
                </div>

            </div>
            <div class="d-flex justify-content-between align-items-center mt-4 mb-2">
                <p class="mb-0">Total Products: {{ productCount }}</p>

                <div class="d-flex align-items-center gap-3">
                    <div class="d-flex align-items-center"
                         style="border: 2px solid #dbdbdb; border-radius: 20px; padding: 4px 12px; font-size: 14px !important;">
                            <span style="color: #000000;">
                                For better usability, zoom out to 90% or collapse the menu
                            </span>
                    </div>

                    <select v-model.number="pagination.perPage" class="form-select form-select-sm w-auto"
                            @change="getProductList(1)">
                        <option value="10">10 per page</option>
                        <option value="20">20 per page</option>
                        <option value="50">50 per page</option>
                        <option value="100">100 per page</option>
                    </select>
                </div>
            </div>

            <div v-if="isLoading" class="loading-overlay">
                <div class="loading-content">
                    <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                    <p class="loading-text mt-3">Loading products...</p>
                </div>
            </div>
        </div>
        <div v-if="products.length > 0">
            <div v-for="product in products" :key="product.id">
                <ProductQuantityDiscount :product="product" :salesChannel="selectedChannel"/>
            </div>
        </div>
        <div v-else-if="!isLoading">
            <p class="text-muted">No product found.</p>
        </div>
        <!-- Pagination -->
        <div v-if="pagination.totalPages > 1" class="d-flex justify-content-center mt-4">
            <nav aria-label="Page navigation">
                <ul class="pagination">

                    <!-- Previous Button -->
                    <li :class="{ disabled: pagination.currentPage === 1 }" class="page-item">
                        <a class="page-link" href="#" @click.prevent="getProductList(pagination.currentPage - 1)">
                            &laquo;
                        </a>
                    </li>

                    <!-- First Page -->
                    <li :class="{ active: pagination.currentPage === 1 }" class="page-item">
                        <a class="page-link" href="#" @click.prevent="getProductList(1)">1</a>
                    </li>

                    <!-- Ellipsis before dynamic range -->
                    <li v-if="startPage > 2" class="page-item disabled">
                        <a class="page-link" href="#">...</a>
                    </li>

                    <!-- Dynamic Page Numbers -->
                    <li v-for="pageNumber in displayedPages" :key="pageNumber"
                        :class="{ active: pageNumber === pagination.currentPage }" class="page-item">
                        <a class="page-link" href="#" @click.prevent="getProductList(pageNumber)">
                            {{ pageNumber }}
                        </a>
                    </li>

                    <!-- Last Page -->
                    <li v-if="pagination.totalPages > 1 && endPage < pagination.totalPages - 1"
                        class="page-item disabled">
                        <a class="page-link" href="#" style="width: max-content">...</a>
                    </li>
                    <li v-if="pagination.totalPages > 1"
                        :class="{ active: pagination.currentPage === pagination.totalPages }" class="page-item">
                        <a class="page-link" href="#" style="width: max-content"
                           @click.prevent="getProductList(pagination.totalPages)">
                            {{ pagination.totalPages }}
                        </a>
                    </li>

                    <!-- Next Button -->
                    <li :class="{ disabled: pagination.currentPage === pagination.totalPages }" class="page-item">
                        <a class="page-link" href="#" @click.prevent="getProductList(pagination.currentPage + 1)">
                            &raquo;
                        </a>
                    </li>

                </ul>
            </nav>
        </div>
    </div>
    <!-- Add this inside <template> -->
    <div id="importQuantityDiscountModal" aria-hidden="true" aria-labelledby="importModalLabel" class="modal fade"
         tabindex="-1">
        <div class="modal-dialog modal-lg">
            <form enctype="multipart/form-data" @submit.prevent="submitImport">
                <div class="modal-content">
                    <div class="modal-header position-relative">
                        <h5 id="importModalLabel" class="modal-title">Import Quantity Discounts</h5>
                        <div
                            class="position-fix top-10 end-0 m-2 bg-light border rounded-pill px-3 py-1 shadow-sm d-flex align-items-center">
                            <small class="text-muted me-2 mb-0">Selected Store:</small>
                            <span class="fw-bold text-dark">{{ getSaleChannelName(selectedChannel) }}</span>
                        </div>
                        <button aria-label="Close" class="btn-close" data-bs-dismiss="modal" type="button"></button>
                    </div>
                    <div class="modal-body">
                        <div v-if="importMessage" class="alert alert-success">
                            {{ importMessage }}<br>
                            The page will reload in 5 seconds...
                        </div>
                        <div v-if="Object.keys(warnings).length" class="alert alert-warning text-sm p-2">
                          <h6 class="mb-1">Warnings:</h6>
                          <span>Quantity discounts could not be added for the following SKUs:</span>
                          <ul>
                            <li v-for="(warning, sku) in warnings" :key="sku" class="mb-1">
                              <strong>{{ sku }} :</strong>
                              <span v-if="warning.discount">{{ warning.discount }}</span>
                            </li>
                          </ul>
                        </div>

                        <div v-if="Object.keys(stockWarnings).length" class="alert alert-warning text-sm p-2">
                          <h6 class="mb-1">⚠️ Stock Information:</h6>
                          <p class="mb-2">The following products do not have enough stock to show quantity discount at the moment:</p>
                          <ul class="mb-2">
                            <li v-for="(warning, sku) in stockWarnings" :key="sku" class="mb-1">
                              <strong>{{ sku }}:</strong> {{ warning.message }}
                            </li>
                          </ul>
                          <p class="mb-0"><em>Quantity discounts have been saved and will be automatically applied when stock becomes available.</em></p>
                        </div>

                      <div v-if="importError" class="alert alert-danger">
                            {{ importError }}
                        </div>
                        <p> To download the template file, <a :href="'/quantity-discount/import-template'"
                                                              target="_blank">Click here</a></p>
                        <div class="alert alert-info mb-2">
                            <ul class="mb-0 ps-3">
                                <li><strong>Only two tiers can be active:</strong> Please fill only two discount columns
                                    and keep others as 0.
                                </li>
                                <li><strong>If more than two discount columns are filled, only the first two will be
                                    activated and the rest will be set to 0 automatically.</strong></li>
                                <li><strong>SKU is required:</strong> Each row must have a valid SKU that exists in the
                                    system.
                                </li>
                                <li><strong>Discount values:</strong> Enter the unit sale price for each active tier.
                                    Use <code>0</code> for inactive tiers.
                                </li>
                                <li><strong>Accepted file types:</strong> CSV or Excel (.csv, .xls, .xlsx).</li>
                                <li><strong>Do not modify column headers</strong> in the template file.</li>
                                <li>After import, quantity discounts will overwrite any existing discounts for the same
                                    SKU and channel.
                                </li>
                            </ul>
                        </div>
                        <input ref="importFile" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                               class="form-control mb-3"
                               required type="file"/>

                    </div>
                    <div class="modal-footer">
                        <button :disabled="isImporting" class="btn btn-primary d-flex align-items-center gap-2" type="submit">
                            <span v-if="isImporting" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            {{ isImporting ? 'Importing...' : 'Upload & Import' }}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
    
    <ProductFilters :initial-filters="activeFilters" @apply-filters="handleFiltersApplied"/>
    
</template>

<script>

import axios from "axios";
import ProductQuantityDiscount from "./ProductQuantityDiscount.vue";
import ProductFilters from "../ProductFilters.vue";
import {debounce} from 'lodash';

export default {
    name: 'QuantityDiscount',
    components: {
        ProductQuantityDiscount,
        ProductFilters,
    },
    data() {
        return {
            activeFilters : {},
            currentFilters: {},
            selectedChannel: this.defaultCompanyId || 2, // Default to CMW if no defaultCompanyId is provided
            searchTerm: '',
            products: [],
            productCount: 0,
            pagination: {
                currentPage: 1,
                perPage: 20,
                totalPages: 0,
                totalElements: 0,
            },
            flags: [
                {"code": 2, "label": "/img/cmw/sales_channels/cmw_it_b2c.png"},
                {"code": 1, "label": "/img/cmw/sales_channels/cmw_it_b2b.png"},
                {"code": 3, "label": "/img/cmw/sales_channels/cmw_de_b2c.png"},
                {"code": 4, "label": "/img/cmw/sales_channels/cmw_fr_b2c.png"},
                {"code": 6, "label": "/img/cmw/sales_channels/cmw_uk_b2c.png"},
            ],
            channelNames: {
                1: {label: "B2B"},
                2: {label: "CMW"},
                3: {label: "CMW_DE"},
                4: {label: "CMW FR"},
                6: {label: "CMW UK"}
            },
            isLoading: true,
            importError: '',
            importMessage: '',
            importSuccess: false,
            warnings: {},
            stockWarnings: {},
            isImporting: false
        }
    },
    props: {
        defaultCompanyId: {
            type: Number,
            required: true
        },
    },
    methods: {
        getSaleChannelName(id) {
            return this.channelNames[id].label;
        },
        getProductList(page = 1) {
            this.isLoading = true;
            this.pagination.currentPage = page;
            this.products = []
            
            this.updateURL();

            const params = {
                searchTerm: this.searchTerm,
                salesChannel: this.selectedChannel,
                page: page,
                perPage: this.pagination.perPage
            };

            const apiFilters = this.transformFiltersForAPI(this.currentFilters);
            Object.entries(apiFilters).forEach(([key, value]) => {
                params[`filters[${key}]`] = value;
            });

            axios.get('quantity-discount/product-list', {
                params: params
            })
                .then(response => {

                    this.products = response.data.data;
                    this.productCount = response.data.pagination.totalElements;
                    this.pagination.totalPages = response.data.pagination.totalPages;
                    this.pagination.totalElements = response.data.pagination.totalElements;
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        openImportModal() {
            this.importMessage = '';
            this.importError = '';
            this.importSuccess = false;
            const modal = new bootstrap.Modal(document.getElementById('importQuantityDiscountModal'));
            modal.show();
        },
        async submitImport() {
            const fileInput = this.$refs.importFile;
            if (!fileInput.files.length) return;

            const file = fileInput.files[0];
            const allowedTypes = [
                'text/csv',
                'application/vnd.ms-excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            ];
            const allowedExtensions = ['csv', 'xls', 'xlsx'];
            const fileExtension = file.name.split('.').pop().toLowerCase();

            if (!allowedTypes.includes(file.type) && !allowedExtensions.includes(fileExtension)) {
                this.importError = 'Please upload a valid CSV or Excel file.';
                return;
            }

            const formData = new FormData();
            formData.append('file', file);
            formData.append('salesChannel', this.selectedChannel);

            this.importError = '';
            this.importMessage = '';
            this.importSuccess = false;
            this.isImporting = true;

            try {
                console.log('Starting Import Process...');
                console.log('File:', file.name);
                console.log('Sales Channel:', this.selectedChannel);

                const response = await axios.post('/quantity-discount/import', formData, {
                    headers: {'Content-Type': 'multipart/form-data'}
                });

                console.log('Import Response Data:', response.data);
                this.importMessage = response.data.message || 'Import successful!';
                this.importSuccess = true;
                this.warnings = response.data.warnings || {};
                this.stockWarnings = response.data.stockWarnings || {};
                console.log('Discount warnings:', response.data.warnings);
                console.log('Stock warnings:', response.data.stockWarnings);


                // Close modal after 5 seconds and reload
                setTimeout(() => {
                    const modal = bootstrap.Modal.getInstance(document.getElementById('importQuantityDiscountModal'));
                    if (modal) modal.hide();
                    window.location.reload();
                }, 10000);
            } catch (e) {
                this.importError = e.response?.data?.message || 'Import failed';
            } finally {
                this.isImporting = false;
            }
        },
        handleFiltersApplied(activeFilters) {
            this.currentFilters = activeFilters;
            this.activeFilters = activeFilters;
            this.pagination.currentPage = 1;
            this.getProductList(1);
        },
        
        updateURL() {
            const params = new URLSearchParams();
            
            params.set('page', this.pagination.currentPage);
            params.set('perPage', this.pagination.perPage);
            
            if (this.searchTerm) {
                params.set('search', this.searchTerm);
            }
            
            if (this.selectedChannel) {
                params.set('salesChannelId[]', this.selectedChannel);
            }
            
            const excludedFilters = ['marginPerc_from', 'marginPerc_to', 'qty_from', 'qty_to'];
            
            if (this.currentFilters) {
                Object.entries(this.currentFilters).forEach(([key, value]) => {
                    if (excludedFilters.includes(key) || value === null || value === undefined || value === '') {
                        return;
                    }
                    
                    if (Array.isArray(value)) {
                        if (value.length > 0) {
                            params.set(key, value.join(','));
                        }
                    } else {
                        params.set(key, value);
                    }
                });
            }
            
            const newURL = `${window.location.pathname}?${params.toString()}`;
            window.history.pushState({ path: newURL }, '', newURL);
        },
        
        readFiltersFromURL() {
            const params = new URLSearchParams(window.location.search);
            const filters = {};
            
            const page = params.get('page');
            if (page) {
                this.pagination.currentPage = parseInt(page);
            }
            
            const perPage = params.get('perPage');
            if (perPage) {
                this.pagination.perPage = parseInt(perPage);
            }
            
            const search = params.get('search');
            if (search) {
                this.searchTerm = search;
            }
            
            const salesChannel = params.get('salesChannelId[]');
            if (salesChannel) {
                this.selectedChannel = parseInt(salesChannel);
            }
            
            const filterKeys = [
                'enabled', 'outOfProduction', 'hasImages', 'search', 'brand', 'tag', 
                'collection', 'order_by', 'category', 'vintage', 'winelist', 
                'philosophy', 'style', 'country', 'region', 'productionArea', 
                'action', 'channel', 'productstatus', 'price_from', 'price_to',
                'bollini', 'handcrafted', 'new', 'promotion', 'differentLowestPrice', 'discount', 'quantityDiscount'
            ];
            const excludedFilters = ['marginPerc_from', 'marginPerc_to', 'qty_from', 'qty_to'];
            
            for (const [key, value] of params.entries()) {
                if (key === 'page' || key === 'perPage' || key === 'search' || key.startsWith('salesChannelId')) {
                    continue;
                }
                
                if (filterKeys.includes(key) && !excludedFilters.includes(key)) {
                    if (value.includes(',')) {
                        filters[key] = value.split(',').map(v => {
                            const trimmed = v.trim();
                            return isNaN(trimmed) ? trimmed : (trimmed.includes('.') ? parseFloat(trimmed) : parseInt(trimmed));
                        }).filter(v => v !== '');
                    } else {
                        let convertedValue = value;
                        
                        if (key === 'price_from' || key === 'price_to') {
                            convertedValue = value === '' ? '' : (value.includes('.') ? parseFloat(value) : parseInt(value));
                        }
                        else if (key === 'differentLowestPrice') {
                            convertedValue = value === 'true' || value === '1' || value === true || value === 1;
                        }
                        else if (key === 'outOfProduction' && value === 'no') {
                            convertedValue = '';
                        }
                        else if (key === 'hasImages' && value === 'no') {
                            convertedValue = '';
                        }
                        
                        filters[key] = convertedValue;
                    }
                }
            }
            
            if (Object.keys(filters).length > 0) {
                this.currentFilters = { ...this.currentFilters, ...filters };
                this.activeFilters = filters;
            }
            
            return filters;
        },
        
        transformFiltersForAPI(filters) {
            const apiFilters = {};
            if (!filters) return apiFilters;
            
            Object.entries(filters).forEach(([key, value]) => {
                if (value === null || value === undefined || value === '') {
                    return;
                }
                
                if (Array.isArray(value)) {
                    if (value.length > 0) {
                        apiFilters[key] = value.join(',');
                    }
                } else {
                    apiFilters[key] = value;
                }
            });
            
            return apiFilters;
        },
        handlePopState() {
            this.readFiltersFromURL();
            this.getProductList(this.pagination.currentPage);
        }

    },
    mounted() {
        const urlFilters = this.readFiltersFromURL();
        
        if (Object.keys(urlFilters).length === 0) {
            const saved = localStorage.getItem('productFilters');
            if (saved) {
                try {
                    const data = JSON.parse(saved);
                    const oneDayAgo = new Date(Date.now() - 24 * 60 * 60 * 1000);
                    const savedTime = new Date(data.timestamp);

                    const userId = document.querySelector('meta[name="user-id"]')?.getAttribute('content') || 'unknown';

                    if (savedTime > oneDayAgo && data.user === userId) {
                        this.currentFilters = { ...this.currentFilters, ...data.filters };
                        this.activeFilters = data.filters;
                    }
                } catch (error) {
                    console.error('Error loading saved filters:', error);
                }
            }
        }
        
        window.addEventListener('popstate', this.handlePopState);

        this.getProductList(this.pagination.currentPage);
    },
    
    beforeDestroy() {
        window.removeEventListener('popstate', this.handlePopState);
    },

    watch: {
        searchTerm: debounce(function () {
            this.getProductList(1)
        }, 500),

        selectedChannel() {
            this.getProductList(1);
        }
    },
    computed: {
        startPage() {
            return Math.max(2, this.pagination.currentPage - 2);
        },
        endPage() {
            return Math.min(this.pagination.totalPages - 1, this.pagination.currentPage + 2);
        },
        displayedPages() {
            const pages = [];
            for (let i = this.startPage; i <= this.endPage; i++) {
                pages.push(i);
            }
            return pages;
        }
    }
}
</script>

